import APIError from '../exceptions/APIError';
import AppError from '../exceptions/AppError';

export const isApiError = (error: any): boolean => error instanceof APIError;

export const isRuntimeError = (error: any): boolean =>
  !(error instanceof AppError);
